<div class="bpx-dialog bpx-dialog--wide save-study-dialog">
  <h2 mat-dialog-title>Save Study</h2>
    <mat-dialog-content class="save-study-dialog-content">
      <div class="save-study-scroll">
      <div>
        <div class="bpx-detail bpx-detail--compact save-study-summary">
          <div class="bpx-detail__item">
            <span class="bpx-detail__label">Panel</span>
            <span class="bpx-detail__value" id="panel-name">{{ panelName }}</span>
          </div>
          <div class="bpx-detail__item">
            <span class="bpx-detail__label">Study Phase</span>
            <span class="bpx-detail__value" id="study-phase">{{ panelPhase }}</span>
          </div>
          <div class="bpx-detail__item">
            <span class="bpx-detail__label">Operator</span>
            <span class="bpx-detail__value">{{ operator }}</span>
          </div>
        </div>
        <div class="bpx-control">
          <span class="bpx-control__label" id="save-study-name-label">Study Name</span>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="bpx-field save-study-field">
            <input matInput [(ngModel)]="studyName" aria-labelledby="save-study-name-label" />
          </mat-form-field>
        </div>
        <div class="save-study-comments">
          <div class="bpx-control">
            <span class="bpx-control__label" id="save-study-comments-label">Comments</span>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="bpx-field bpx-field--textarea save-study-field">
              <textarea matInput rows="3" [ngModel]="commentInput" (ngModelChange)="handleCommentInputChange($event)" aria-labelledby="save-study-comments-label"></textarea>
            </mat-form-field>
          </div>
          @if (commentError) {
          <div class="bpx-error" role="alert">
            <mat-icon>error_outline</mat-icon>
            <span>{{ commentError }}</span>
          </div>
          }
        </div>

        <mat-expansion-panel class="linked-studies-panel" [(expanded)]="showLinkPicker" [disabled]="!canLinkStudies || (!isSaveAs && !linksKnown)">
          <mat-expansion-panel-header>
            <mat-panel-title>Linked Studies</mat-panel-title>
            <mat-panel-description>{{ linkedStudiesSummary }}</mat-panel-description>
          </mat-expansion-panel-header>
          @if (isSaveAs) {
          <p class="linked-studies-auto-note">
            This study is being saved under a new name, so it will be linked to
            <strong>{{ originalStudyName }}</strong> automatically.
          </p>
          }
          <app-study-link-picker
            [currentRunName]="studyName"
            [linkedRunNames]="pickerLinkedRunNames"
            (linkedRunNamesChange)="onLinkedChange($event)">
          </app-study-link-picker>
        </mat-expansion-panel>
      </div>

      <div>
        @if (errorMessage && !isProcessing) {
          <div class="bpx-error" role="alert">
            <mat-icon>error_outline</mat-icon>
            <span>{{ errorMessage }}</span>
          </div>
        }
      </div>
      @if (isCommitted) {
      <div class="bpx-error save-study-committed-notice" role="alert">
        <mat-icon>error_outline</mat-icon>
        <span>This study has been committed and is finalized. Committed studies cannot be saved.</span>
      </div>
      }
      </div>
    </mat-dialog-content>

    <mat-dialog-actions class="save-study-actions" [ngClass]="(errorMessage && !isProcessing) ? 'mt-4' : 'mt-8'">
      <button class="bpx-btn bpx-btn--primary" matRipple (click)="saveStudy()" [disabled]="isCommitted || (!isProcessing && panelName === '' && panelPhase === '')">
        Save
      </button>
      <button class="bpx-btn" matRipple [mat-dialog-close] [disabled]="isProcessing">
        Cancel
      </button>
    </mat-dialog-actions>
</div>
